import { render, staticRenderFns } from "./QuoteCoverage.vue?vue&type=template&id=92fece12&scoped=true"
import script from "./QuoteCoverage.vue?vue&type=script&lang=js"
export * from "./QuoteCoverage.vue?vue&type=script&lang=js"
import style0 from "./QuoteCoverage.vue?vue&type=style&index=0&id=92fece12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92fece12",
  null
  
)

export default component.exports